import {ReportType} from "@mytour/shared";
import {Field2} from "@mytour/ui/form";
import {useState} from "react";
import type {UseFormReturn} from "react-hook-form";
import z from "zod";
import {MetadataEditModal} from "../../../metadata/MetadataEditModal";
import {useListMetadata} from "../../../query/reportQueries";

export const step6Schema = z.object({
  synthese: z.string().optional(),
  recommandations: z.string().optional(),
});

export type Step6Form = z.infer<typeof step6Schema>;

type Props = {
  hookForm: UseFormReturn<Step6Form>;
  disabled: boolean;
};

export function Step6({hookForm, disabled}: Props) {
  const [isEditingSuggestions, setIsEditingSuggestions] = useState(false);
  const {data: suggestions} = useListMetadata(ReportType.SPECTRUM);

  return (
    <>
      <div>
        <h5 style={{marginBottom: "16px"}}>Synthèse et recommandations</h5>
        <Field2
          name="synthese"
          label="Synthèse"
          type="textarea"
          hookForm={hookForm}
          disabled={disabled}
        />
        <Field2
          name="recommandations"
          label="Recommandations"
          type="textarea"
          suggestions={suggestions && suggestions.length > 0 ? suggestions : undefined}
          hookForm={hookForm}
          disabled={disabled}
          onEditSuggestions={() => {
            setIsEditingSuggestions(true);
          }}
        />
      </div>
      {isEditingSuggestions && (
        <MetadataEditModal onClose={() => setIsEditingSuggestions(false)} />
      )}
    </>
  );
}
